import createTypes from 'redux-create-action-types';

export const asyncActionTypeRequest = (baseAction) => `${baseAction}_REQUEST`;
export const asyncActionTypeSuccess = (baseAction) => `${baseAction}_SUCCESS`;
export const asyncActionTypeFailure = (baseAction) => `${baseAction}_FAILURE`;

export default createTypes(
  'SELECT_SM_SUPPLIER',
  'GET_SM_SUPPLIER_QUANTITY',
  'GET_SM_FACTORY_QUANTITY',

  'GET_SM_SUPPLIER_LIST',
  'GET_SM_FACTORY_LIST',

  'GET_SM_FACTORY_LIST_BY_SUPPLIER_ID',

  'UPDATE_SM_SUPPLIER_LIST_PAGINATION',
  'UPDATE_SM_SUPPLIER_LIST_FILTER',
  'UPDATE_SM_SUPPLIER_LIST_SORTER',
  'UPDATE_SM_SUPPLIER_LIST_SEARCH',
  'UPDATE_SM_SUPPLIER_STATUS',

  'UPDATE_SM_FACTORY_LIST_PAGINATION',
  'UPDATE_SM_FACTORY_LIST_FILTER',
  'UPDATE_SM_FACTORY_LIST_SORTER',
  'UPDATE_SM_FACTORY_LIST_SEARCH'
);